var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popup-view',_vm._b({on:{"close":function($event){return _vm.$emit('close')}}},'popup-view',_vm.$attrs,false),[_c('clock-view',{attrs:{"value":_vm.value},on:{"input":_vm.input}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }